/* src/app/terms-of-use/terms-of-use.component.scss */
#terms-clear-formatting {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #fff;
  text-align: left;
  color: #262933;
  overflow: auto;
  padding-bottom: 100px;
}
h1 {
  margin: 60px 0 50px 0;
  border-bottom: 1px solid #555969;
  padding-bottom: 5px;
}
h2 {
  font-size: 24px;
  margin: 45px 0 6px 0;
}
p {
  margin-bottom: 15px;
}
ul {
  margin-bottom: 20px;
}
ul li {
  font-size: 1.286rem;
  margin-bottom: 4px;
}
a {
  color: #262933;
  text-decoration: underline;
}
a:hover {
  color: #262933;
  text-decoration: none;
}
/*# sourceMappingURL=terms-of-use.component.css.map */
